<template>
  <div>
    <vue-element-loading
      style="z-index: 99999;"
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <Term1 v-if="step === 'term1'" @next="updateStep('PdpaMkt')" :fetchApi="false" />
    <PdpaMkt v-if="step === 'PdpaMkt'" @next="updateStep('termNextMoney1')" :fetchApi="false" />
    <TermNextMoney1
      v-if="step === 'termNextMoney1'"
      @next="updateStep('PdpaMktNextMoney')"
      :fetchApi="false"
    />
    <PdpaMktNextMoney
      v-if="step === 'PdpaMktNextMoney'"
      @next="updateStep('term2')"
      :fetchApi="false"
    />
    <Term2
      v-if="step === 'term2'"
      @next="updateStep('regisForm')"
      @back="updateStep('PdpaMktNextMoney')"
      :fetchApi="false"
    />
    <RegisForm
      v-if="step === 'regisForm'"
      @next="handlePhoneListOtp()"
      @back="updateStep('term2')"
    />
    <SelectPhoneNo v-if="step === 'selectPhone'" @next="sendOtp" @back="updateStep('term2')" />
    <Otp v-if="step === 'otp'" @next="updateStep('showData')" @resend="sendOtp" />
    <ShowData v-if="step === 'showData'" />
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import Term1 from '@/components/regis/term1'
import TermNextMoney1 from '@/components/regis/TermNextMoney1'
import Term2 from '@/components/regis/term2'
import RegisForm from '@/components/regis/regisForm'
import SelectPhoneNo from '@/components/regis/SelectPhoneNo'
import Otp from '@/components/regis/otp'
import ShowData from '@/components/regis/ShowData'
import PdpaMkt from '@/components/regis/PdpaMkt'
import PdpaMktNextMoney from '@/components/regis/PdpaMktNextMoney'
import otpApi from '@/api/otp'
import config from '@/config'

export default {
  components: {
    VueElementLoading,
    Term1,
    Term2,
    RegisForm,
    Otp,
    ShowData,
    PdpaMkt,
    SelectPhoneNo,
    TermNextMoney1,
    PdpaMktNextMoney
  },
  data() {
    return {
      loading: false,
      checkbox: false,
      step: 'term1'
    }
  },
  mounted() {},
  methods: {
    updateStep(name) {
      this.step = name
    },
    handlePhoneListOtp() {
      const regisData = this.$store.state.regisData
      if (regisData.phoneNumbers && regisData.phoneNumbers.length) {
        if (regisData.phoneNumbers.length > 1) {
          this.updateStep('selectPhone')
        } else {
          this.sendOtp(regisData.phoneNumbers[0])
        }
      } else {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่มีข้อมูลเบอร์โทรศัพท์ในระบบ'
        })
      }
    },
    async sendOtp(phoneNo) {
      if (!phoneNo) {
        this.$swal.fire({
          type: 'error',
          text: 'ไม่มีข้อมูลเบอร์โทรศัพท์ในระบบ'
        })
        return
      }
      try {
        // fetch api send otp
        this.$store.state.regisData.phoneno = phoneNo
        this.loading = true
        const configData = {
          body: {
            page_id: config.pageid,
            phone_number: phoneNo
          }
        }
        const response = await otpApi.postSendOtp(configData)
        this.$store.dispatch('setRefData', response.data.data)
        this.updateStep('otp')
      } catch (error) {
        this.$swal.fire({
          type: 'error',
          text: 'ส่ง OTP ไม่สำเร็จ'
        })
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    }
  }
}
</script>

<style>
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
